import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi, { type HttpBackendOptions } from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { env, publicAssetUrl } from '@maxus/website/constants'

i18n
  .use(HttpApi) // 懒加载 http backend
  .use(LanguageDetector)
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    fallbackLng: 'zh',
    supportedLngs: ['zh', 'en'],
    load: 'languageOnly', // zh-CN -> zh, en-US -> en
    ns: ['common'],
    defaultNS: 'common',
    debug: env.VITE_NODE_ENV === 'development',
    interpolation: { escapeValue: false },
    react: { useSuspense: true }, // 与 Suspense 配合
    backend: {
      // Electron 生产环境需要绝对 file: URL，以便后端走本地文件 XHR 路径。
      loadPath: (languages, namespaces) =>
        new URL(publicAssetUrl(`locales/${languages.join('+')}/${namespaces.join('+')}.json`), window.location.href)
          .href,
    },
    detection: {
      order: [
        'querystring',
        'cookie',
        'localStorage',
        'navigator',
      ],
      caches: ['localStorage', 'cookie'],
    },
  })

export default i18n
